import reframe from 'reframe.js';
import Modal from './Modal';

export default class MasonryVideo {
  constructor($el, event) {
    this.$el = $el;
    this.modal = null;

    const $target = $(event.currentTarget);
    const modalID = $target.attr('data-masonry-video');
    const $modal = this.$el.find(`[data-modal-id=${modalID}]`);

    this.modal = new Modal({
      el: $modal,
      callbacks: {
        onOpen: $els => this._open($els),
        onClose: () => this._close()
      }
    });

    this.modal.open();
  }

  onSectionUnload() {
    if (this.modal) {
      return this.modal.close();
    }
  }

  _open($els) {
    let $videoContents;
    const { $modal, $contents } = $els;

    const $videoJson = $modal.find('[data-masonry-video]');

    try {
      $videoContents = $(JSON.parse($videoJson.text()));
    } catch (error) {
      return console.warn('Unable to parse contents of video');
    }
    const $vid = $contents.html($videoContents);
    reframe($vid.find('iframe').addBack('iframe'));

    return this.modal.showModal();
  }

  _close() {
    return this.modal = null;
  }
}


